import { WidgetAutocheck } from "@redotech/redo-storefront-widget-common/widget";

export function isTryFirstSetup(autocheck: WidgetAutocheck) {
  return autocheck.tryFirst?.sellingPlanId;
}
